import { useCallback, useEffect, useState } from 'react';
import baseURL from '../baseURL';

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json'
  };
}

export default function useVatavData() {
  const [accounts, setAccounts] = useState([]);
  const [pledges, setPledges] = useState([]);
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  const loadAll = useCallback(async () => {
    setLoading(true);
    setErr('');
    try {
      const [a, p, t] = await Promise.all([
        fetch(`${baseURL}/vatav/accounts`, { headers: authHeaders() }).then((r) => r.json()),
        fetch(`${baseURL}/vatav/pledges`, { headers: authHeaders() }).then((r) => r.json()),
        fetch(`${baseURL}/vatav/transfers`, { headers: authHeaders() }).then((r) => r.json())
      ]);
      if (!a.success) throw new Error(a.message || 'accounts');
      if (!p.success) throw new Error(p.message || 'pledges');
      if (!t.success) throw new Error(t.message || 'transfers');
      setAccounts(a.data || []);
      setPledges(p.data || []);
      setTransfers(t.data || []);
    } catch (e) {
      setErr(e.message || String(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadAll();
  }, [loadAll]);

  const createAccount = async ({ name, mobileNo }) => {
    setMsg('');
    setErr('');
    try {
      const res = await fetch(`${baseURL}/vatav/accounts`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ name, mobileNo })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Failed');
      setMsg('Vatav account created.');
      await loadAll();
    } catch (e) {
      setErr(e.message || String(e));
      throw e;
    }
  };

  const submitTransfer = async ({ vatavAccountId, lines }) => {
    setMsg('');
    setErr('');
    try {
      const res = await fetch(`${baseURL}/vatav/transfers`, {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ vatavAccountId, lines })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Transfer failed');
      setMsg(`Transferred: ${(data.data || []).map((d) => d.vatavTicketNo).join(', ')}`);
      await loadAll();
      return data;
    } catch (e) {
      setErr(e.message || String(e));
      throw e;
    }
  };

  return {
    accounts,
    pledges,
    transfers,
    loading,
    err,
    msg,
    setErr,
    setMsg,
    loadAll,
    createAccount,
    submitTransfer
  };
}
